import { Card, CardContent, SvgIconTypeMap, Typography } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";

import React from "react";

type propsType = {
  title: string;
  count: number;
  Icon: OverridableComponent<SvgIconTypeMap<{}, "svg">> & {
    muiName: string;
  };
};
export default function TotalCard({ title, count, Icon }: propsType) {
  return (
    <Card
      raised={false}
      sx={{ boxShadow: 0, minHeight: "100px" }}
      title={`in year ${new Date().getFullYear()}`}
    >
      <CardContent color={"text.secondary"}>
        <Typography
          fontSize={14}
          fontWeight={500}
          mb={2}
          display="flex"
          alignItems={"center"}
          justifyContent="center"
          sx={{ minHeight: "50px" }}
        >
          {title}
          {<Icon sx={{ mx: 1 }} fontSize="small" />}
        </Typography>
        <Typography fontSize={18} fontWeight={600}>
          {count}
        </Typography>
      </CardContent>
    </Card>
  );
}
